// src/data/WebsiteLeadData.js

const websiteLeadData = {
    title: "Website Lead Generation",
    subtitle: "",
    description: "We design high-converting websites that automatically capture customer interest and route it directly to your CRM, phone, or inbox. Every click can turn into a client with our optimized lead forms and tracking systems.",
    benefits: [
        "Instant text/email alerts for new leads",
        "Smart contact forms with image uploads",
        "CRM & email marketing integration",
        "SEO-optimized landing pages",
        "Custom thank-you pages with tracking",
    ],
    stats: {
        conversionRate: "3.5x higher",
        avgResponseTime: "Under 5 minutes",
        clientsServed: "1200+ subscribers captured"
    },
    cta: {
        text: "See It in Action",
        link: "/appstore" // or wherever your demo/live apps are
    },
    image: "https://res.cloudinary.com/duz4vhtcn/image/upload/v1749594165/Untitled_design_7_o9dfvi.png"
};

export default websiteLeadData;
